import { MainView } from '@repo/ui/Views';
import SettingsTabNav from '../components/SettingsTabNav';

const Settings = () => {
  return (
    <MainView title="Settings">
      <SettingsTabNav />
    </MainView>
  );
};

export default Settings;
